export const DEFAULT_TIMEOUT = 100000;
export const CompensationKey = "CL";
export const AnnualLeaveKey = "AL";
export const DefaultLang = "EN";
export const OneSignalID = "80588cbc-877c-43e3-abb7-25dd61282e8c";
export const datePickerLang = {
  days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ]
};



// WEBPACK FOOTER //
// ./src/constants/globalConstants.js